import Toast from './toast.component';

export default Toast;
